import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function CommunityPortal() {
  const [feed, setFeed] = useState([]);
  const [cfg, setCfg] = useState({});
  const [text, setText] = useState("");

  const load = async () => {
    try {
      const [f, c] = await Promise.all([api.get("/wins/feed"), api.get("/config")]);
      setFeed(f.data); setCfg(c.data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const post = async () => {
    if (!text.trim()) return;
    try { await api.post("/wins", { text, category: "community" }); setText(""); toast.success("Shared."); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-8">
      <div>
        <div className="label-eyebrow">Community · BA30 Club</div>
        <h1 className="wordmark mt-3 text-4xl md:text-5xl uppercase">Show Up. Cheer Wins.</h1>
      </div>
      {cfg?.discord_invite_url && (
        <a href={cfg.discord_invite_url} target="_blank" rel="noreferrer" className="btn-secondary" data-testid="portal-discord">
          Open the BA30 Discord →
        </a>
      )}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="label-eyebrow">Share A Win</div>
        <div className="mt-3 flex gap-2">
          <input value={text} onChange={(e) => setText(e.target.value)} placeholder="First 10K day in a row!"
            className="flex-1 rounded-md border border-input bg-background px-3 py-2 text-sm" data-testid="community-win-input" />
          <button onClick={post} className="btn-primary btn-sm" data-testid="community-win-post">Share</button>
        </div>
      </div>
      <div className="space-y-3">
        <div className="label-eyebrow">Wins Feed</div>
        {feed.length === 0 && <div className="text-sm text-muted-foreground">Be the first to share a win.</div>}
        {feed.map((w) => (
          <div key={w.id} className="bg-card border border-border rounded-lg p-5" data-testid={`feed-${w.id}`}>
            <div className="text-sm">{w.text}</div>
            <div className="text-xs text-muted-foreground mt-2">{w.user_name} · {new Date(w.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
